<template>
  <el-config-provider :locale="currentLocale">
    <div class="app-container">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </el-config-provider>
</template>

<script setup lang="ts" name="App">
import { ElConfigProvider } from 'element-plus'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { computed } from 'vue'

import { i18n } from '@/langs'

import { LanguageEnum } from './constants'

const currentLocale = computed(() => {
  const localeName = i18n.global.locale.value
  if (localeName === LanguageEnum.ZH_CN) return zhCn
  else if (localeName === LanguageEnum.EN) return en
  else return en
})
</script>

<style lang="scss"></style>
